import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cgu: 'Terms of Service',
    close: 'Close',
    steps: [
      'You send a referral code',
      'Your contact opens their Shine account',
      'Your contact makes a payment of at least €30 with their Shine card within 45 days of opening their account.',
      'You receive €100 and your contact gets an extra free month.',
    ],
    subtitle: 'Validate your referrals (max. 2) in 4 steps',
    title: 'It’s here! Refer from the web app',
  },
  fr: {
    cgu: 'Conditions Générales d’Utilisation',
    close: 'Fermer',
    steps: [
      'Vous envoyez un code de parrainage',
      'Votre contact ouvre son compte Shine',
      'Votre contact effectue un paiement de 30 € minimium, avec sa carte Shine dans les 45 jours suivant l’ouverture du compte.',
      'Vous recevez 100 € et votre contact bénéficie d’un mois gratuit supplémentaire.',
    ],
    subtitle: 'Validez vos parrainages (max. 2) en 4 étapes',
    title: 'Comment ça marche\xa0?',
  },
} as const);
